module.exports = __webpack_public_path__ + "img/logo_dinflow.0cfa1735.png";